import { CloseCircleFilled } from '@ant-design/icons';
import { useCoordinatedFormState } from '@framework/form/form/coordinator/useCoordinatedFormState.ts';
import { theme as antTheme, Badge, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from '#theme';

const SectionErrorBadge = styled(Badge)`
  &&& {
    .anticon {
      color: ${({ theme }) => theme.colorError};
      font-size: 10px;
    }
  }
`;
const SectionDirtyBadge = styled(Badge)`
  padding-right: 4px;
`;

export interface ISubmissionMenuDirtyBadgeProps {
  sectionId: string;
  submissionModuleId: string | null | undefined;
}

export function SubmissionMenuDirtyBadge(
  props: ISubmissionMenuDirtyBadgeProps,
) {
  const { sectionId, submissionModuleId } = props;
  const { t } = useTranslation();

  const { token } = antTheme.useToken();

  const { dirtyFields, errors } = useCoordinatedFormState({
    name: sectionId,
    formId: submissionModuleId ?? '<undefined>',
  });

  if (!theme.showSummarySectionBadge) return null;

  const isSectionDirty = Object.keys(dirtyFields ?? {}).includes(sectionId);

  const isSectionError = Object.keys(errors ?? {}).includes(sectionId);

  if (!isSectionDirty) return null;

  const title = isSectionError
    ? t(
        'submission-menu.section.dirty-badge.error.sezione-non-valida',
        'Sezione non valida',
      )
    : t(
        'submission-menu.section.dirty-badge.dirty.sezione-da-salvare',
        'Sezione da salvare',
      );

  return (
    <Tooltip title={title}>
      <span className="sr-only"> . {title}</span>
      {isSectionError ? (
        <SectionErrorBadge
          aria-label={title}
          count={<CloseCircleFilled aria-hidden="true" />}
        />
      ) : (
        <SectionDirtyBadge aria-label={title} color={token.colorWarning} />
      )}
    </Tooltip>
  );
}
